<div class="change-details">
    <div class="flex-column-item" >
        <div>
            <div class="flex-row-item" >
                <div class="flex-20" >
                    <label>Target Entity</label>
                </div>
                <div class="flex-offset-3 flex-80" [attr.data-testid]="change.changeSetOrder + '_targetEntity'"   >
                    {{ change.targetEntity }}
                </div>
            </div>
        </div>
        <div>
            <div class="flex-row-item" >
                <div class="flex-20" >
                    <label>Command Class</label>
                </div>
                <div class="flex-offset-3 flex-80" [attr.data-testid]="change.changeSetOrder + '_commandClass'"   >
                    {{ change.commandClass }}
                </div>
            </div>
        </div>
        <div>
            <div class="flex-row-item" >
                <div class="flex-20" >
                    <label>Command Data</label>
                </div>
                <div class="flex-offset-3 flex-80" [attr.data-testid]="change.changeSetOrder + '_commandData'"   >
                    {{ change.commandData }}
                </div>
            </div>
        </div>
        <div>
            <div class="flex-row-item" >
                <div class="flex-20" >
                    <label>Target ID</label>
                </div>
                <div class="flex-offset-3 flex-80" [attr.data-testid]="change.changeSetOrder + '_targetId'"   >
                    {{ change.targetId }}
                </div>
            </div>
        </div>
        <div>
            <div class="flex-row-item" >
                <div class="flex-20" >
                    <label>ID</label>
                </div>
                <div class="flex-offset-3 flex-80" [attr.data-testid]="change.changeSetOrder + '_id'"   >
                    {{ change.id }}
                </div>
            </div>
        </div>
        <div>
            <div class="flex-row-item" >
                <div class="flex-20" >
                    <label>Created By</label>
                </div>
                <div class="flex-offset-3 flex-80" [attr.data-testid]="change.changeSetOrder + '_createdBy'"   >
                    {{ change.createdBy }}
                </div>
            </div>
        </div>
        <div>
            <div class="flex-row-item" >
                <div class="flex-20" >
                    <label>Created Date</label>
                </div>
                <div class="flex-offset-3 flex-80" [attr.data-testid]="change.changeSetOrder + '_createdDate'"   >
                    {{ change.createdDate | date:'full'}}
                </div>
            </div>
        </div>
<!--        Leaving this here in case we want to add a delete option back to change sets at some point in the future.-->
<!--        <div *ngIf="featureScope !== 'Global' && featureScope !== 'Viewer' && featureScope !='Client'">-->
<!--            <button-->
<!--                [attr.data-testid]="'delete_change_button'"-->
<!--                class="button-color mt-2"-->
<!--                [disabled]="change?.id !== lastChange?.id || (isReadOnly$ | async)"-->
<!--                mat-raised-button-->
<!--                matTooltip="Delete last change"-->
<!--                (click)="deleteChange(change.id)"-->
<!--            >Delete-->
<!--            </button>-->
<!--        </div>-->
    </div>
</div>
